<template>
  <div id="purchaser">
    <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl" :coordinationSupplierAuthFlag="coordinationSupplierAuthFlag" :coordinationSystemAuthFlag="coordinationSystemAuthFlag" :supplierManagerAuthFlag="supplierManagerAuthFlag"> </v-topBar>
    <v-notificationTop :noticeInfo="noticeInfo" v-show="showNoticeInfo" ></v-notificationTop>
    <v-header class="hidden-xs hidden-sm" :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl" ></v-header>
    <div class="purchaserCon">
      <v-purchaserBanner :loading="loading" :bannerInfo='bannerInfo' :ratationTime="ratationTime"></v-purchaserBanner>
      <!--<v-dataCount :paramInfo="paramInfo"></v-dataCount>-->
<!--      <v-purchaserLogged :purchaserMenuList="purchaserMenuList" :viewMessageUrl="viewMessageUrl" :companyConfigUrl="companyConfigUrl" class="hidden-xs hidden-sm" :coordinationSystemAuthFlag="coordinationSystemAuthFlag" :ongoingRecruitProjectUrl="ongoingRecruitProjectUrl" :links="data"></v-purchaserLogged>-->
    </div>
    <div class="supplierEntry">
      <v-publiceTit :titleObj='titleObj'></v-publiceTit>
      <div class="searchSupplier">
        <div class="input-group input-group-lg">
          <input type="text" class="form-control"  aria-describedby="sizing-addon1" placeholder="请输入内容" ref="searchHit"  @keyup.enter="jumpHome(hitSerarchUrl)">
          <span class="input-group-btn">
            <button class="btn btn-default" type="button" @click="jumpHome(hitSerarchUrl)">搜索</button>
          </span>
        </div>
        <ul class="clearfix hidden-xs hidden-sm">
          <li class="pull-left" v-for="(hot,index) in hotList" :key="index" @click="jump(hitSerarchUrl,hot.hot)"><a>{{hot.hot}}</a></li>
        </ul>
      </div><!-- /.row -->
      <div class="proCon">
        <div class="tabTitle">
          <ul id="supplierEntryTab" class="nav nav-tabs">
            <li class="active">
              <a href="#material" data-toggle="tab" @click="selectCatagory(1)">物资类<div class="tabLine"></div></a>
            </li>
            <li>
              <a href="#engineering" data-toggle="tab"  @click="selectCatagory(2)">工程类<div class="tabLine"></div></a>
            </li>
            <li>
              <a href="#industry" data-toggle="tab" @click="selectCatagory(3)">工业类<div class="tabLine"></div></a>
            </li>
            <li>
              <a href="#service" data-toggle="tab" @click="selectCatagory(4)">服务类<div class="tabLine"></div></a>
            </li>
          </ul>
        </div>
        <div class="tabCon">
          <div id="supplierEntryTabContent" class="tab-content">
            <div class="clearfix tabConBox tab-pane fade in active" id="material">
              <v-supplierEntryList :supplierEntryInfo="supplierEntryListMaterial" :viewSupplierUrl="viewSupplierUrl" :warehousingUrl="warehousingUrl" :hitSearchUrl="hitSearchUrl" :supplierLoad="supplierLoad" :nodata="noData" :viewExamineUrl="viewExamineUrl" :goEnterpriseResourceUrl="goEnterpriseResourceUrl"></v-supplierEntryList>
              <div class="supplierEntryMore" v-show="!noData">
                <a class="listMore hidden-xs hidden-sm"  @click="jumpPage(yellowPage)">MORE</a>
                <a class="listMore hidden-md hidden-lg"  @click="mobileBox">MORE</a>
              </div>
            </div>
            <div class="clearfix tabConBox tab-pane fade" id="engineering">
              <v-supplierEntryList :supplierEntryInfo="supplierEntryListProject" :viewSupplierUrl="viewSupplierUrl" :warehousingUrl="warehousingUrl" :hitSearchUrl="hitSearchUrl" :supplierLoad="supplierLoad" :nodata="noData" :viewExamineUrl="viewExamineUrl" :goEnterpriseResourceUrl="goEnterpriseResourceUrl"></v-supplierEntryList>
              <div class="supplierEntryMore" v-show="!noData">
                <a class="listMore hidden-xs hidden-sm"  @click="jumpPage(yellowPage)">MORE</a>
                <a class="listMore hidden-md hidden-lg"  @click="mobileBox">MORE</a>
              </div>
            </div>
            <div class="clearfix tabConBox tab-pane fade" id="industry">
              <v-supplierEntryList :supplierEntryInfo="supplierEntryListIndustry" :viewSupplierUrl="viewSupplierUrl" :warehousingUrl="warehousingUrl" :hitSearchUrl="hitSearchUrl" :supplierLoad="supplierLoad" :nodata="noData" :viewExamineUrl="viewExamineUrl" :goEnterpriseResourceUrl="goEnterpriseResourceUrl"></v-supplierEntryList>
              <div class="supplierEntryMore" v-show="!noData">
                <a class="listMore hidden-xs hidden-sm"  @click="jumpPage(yellowPage)">MORE</a>
                <a class="listMore hidden-md hidden-lg"  @click="mobileBox">MORE</a>
              </div>
            </div>
            <div class="clearfix tabConBox tab-pane fade" id="service">
              <v-supplierEntryList :supplierEntryInfo="supplierEntryListService" :viewSupplierUrl="viewSupplierUrl" :warehousingUrl="warehousingUrl"  :hitSearchUrl="hitSearchUrl" :supplierLoad="supplierLoad" :nodata="noData" :viewExamineUrl="viewExamineUrl" :goEnterpriseResourceUrl="goEnterpriseResourceUrl"></v-supplierEntryList>
              <div class="supplierEntryMore" v-show="!noData">
                <a class="listMore hidden-xs hidden-sm"  @click="jumpPage(yellowPage)">MORE</a>
                <a class="listMore hidden-md hidden-lg"  @click="mobileBox">MORE</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-collectingResources :protocolInfo='protocolInfo' :viewProtocolDetailUrl='viewProtocolDetailUrl' ></v-collectingResources>
    <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos'></v-footer>
    <v-backToTop></v-backToTop>
    <privacy-policy :isShow="visibleShow" @closed="visibleShow=false"></privacy-policy>

<!--  2020满意度调查  -->
<!--    <el-dialog-->
<!--      custom-class="questionnaire hidden-xs hidden-sm"-->
<!--      title=""-->
<!--      :modal-append-to-body="false"-->
<!--      :close-on-click-modal="false"-->
<!--      :close-on-press-escape="false"-->
<!--      :show-close="false"-->
<!--      :visible.sync="surveyVisible">-->
<!--      <p v-if="userInfo" class="userName">尊敬的{{userInfo.trueName}}：</p>-->
<!--      <p style="text-indent: 24px;">感谢您一直以来对一链网的支持！</p>-->
<!--      <p style="text-indent: 24px;">为后续给您提供更优质的服务，现诚挚地邀请您抽出【2分钟】时间，填写2020年上半年一链网采购商用户满意度调研问卷。此次问卷调研均为匿名形式，不会透露任何信息；该调研数据仅用于一链网进行用户满意度分析使用。感谢您的配合与支持！</p>-->
<!--      <span class="questionBtn" style="display:block;text-align: center;">-->
<!--        <el-button type="primary" @click="surveyDialogFn(true)">现在去填写</el-button>-->
<!--        <el-button @click="surveyFn">以后再说</el-button>-->
<!--      </span>-->
<!--      <div class="serverCon clearfix">-->
<!--        <div class="pull-left">-->
<!--          <h5>关注一链网服务号，随时掌握以下动态：</h5>-->
<!--          <ul>-->
<!--            <li>1､最新招标项目</li>-->
<!--            <li>2､采购小知识</li>-->
<!--            <li>3､优质采购商推荐</li>-->
<!--            <li>4､最新活动通知</li>-->
<!--          </ul>-->
<!--        </div>-->
<!--        <div class="pull-right">-->
<!--          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/server_erwm.png" alt="">-->
<!--          <p style="font-size: 12px;color: #A8ACB2;line-height: 16px;text-align: center;margin-top: 5px;">打开微信扫一扫</p>-->
<!--        </div>-->
<!--      </div>-->
<!--    </el-dialog>-->

    <!-- 一链网服务号 -->
    <!-- <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>
<script>
import header from '@/components/v-header/header'
import notificationTop from '@/components/notificationTop'
import purchaserBanner from '@/components/purchaserBanner'
import dataCount from '@/components/data-count'
import purchaserLogged from '@/components/purchaserLogged'
import topBar from '@/components/topBar'
import publiceTit from '@/components/publiceTit'
import supplierEntryList from '@/components/supplierEntryList'
import collectingResources from '@/components/collectingResources'
import footer from '@/components/v-footer'
import backToTop from '@/components/backToTop'
import { mapState } from 'vuex'
import Cookies from 'js-cookie'
import {customTabClick} from '@/assets/js/sensors'

export default {
  data() {
    return {
      visibleShow: false,
      qrFocusChecked: false,
      dialogVisible: false,
      hitSearchUrl:'',
      enterpriseResourceBaseUrl:'',
      yellowPageColumn:{},
      productAndSolutionColumn:{},
      navInfo:{},
      titleObj: {name: '入驻供应商', eng: 'SUPPLIER ENTRY'},
      supplierEntryList: [{title: '浙江金诚工程造价咨询事务所有限公司', text: '主营：助力金融机构和非金融机构更好地评估、量化、防范目标客户的…'}, {title: '浙江金诚工程造价咨询事务所有限公司', text: '主营：助力金融机构和非金融机构更好地评估、量化、防范目标客户的…'}, {title: '浙江金诚工程造价咨询事务所有限公司', text: '主营：助力金融机构和非金融机构更好地评估、量化、防范目标客户的…'}, {title: '浙江金诚工程造价咨询事务所有限公司', text: '主营：助力金融机构和非金融机构更好地评估、量化、防范目标客户的…'}, {title: '浙江金诚工程造价咨询事务所有限公司', text: '主营：助力金融机构和非金融机构更好地评估、量化、防范目标客户的…'}, {title: '浙江金诚工程造价咨询事务所有限公司', text: '主营：助力金融机构和非金融机构更好地评估、量化、防范目标客户的…'}],
      supplierEntryListMaterial:[],
      supplierEntryListProject:[],
      supplierEntryListIndustry:[],
      supplierEntryListService:[],
      warehousingUrl:"",
      bannerInfo: {},
      paramInfo:{},
      webConfigInfo:{},
      hotList:[],
      searchWord:"",
      hitSerarchUrl:"",
      yellowPage:"",
      purchaserMenuList:{},
      protocolInfo:{},
      footerColumnInfos:[],
      viewProtocolDetailUrl:"",
      navigationColumnInfos:[],
      noticeInfo:[],
      viewMessageUrl:'',
      ratationTime:undefined,
      loading:true,
      supplierLoad:true,
      companyInfo:{},
      orgIdentitys:[],
      companyId:'',
      trueName:'',
      userId:'',
      userTag:'',
      companyConfigUrl:'',
      noData:false,
      coordinationSupplierAuthFlag:'',
      coordinationSystemAuthFlag:'',
      supplierManagerAuthFlag:'',
      supplierManagerUrl:'',
      coordinationManagerUrl:'',
      viewExamineUrl:'',
      goEnterpriseResourceUrl:'',
      viewSupplierUrl:'',
      coordinationSupplierUrl:'',
      recruitPurchaserUrl:'',
      recruitSupplierUrl:'',
      mroShoppingMallUrl:'',
      showNoticeInfo:false,
      ongoingRecruitProjectUrl:'',
      surveyVisible:false,
      userInfo:{},
//      leadSteps:{
//        firstStep:false,
//        secondStep:false,
//        thirdStep:false,
//        fourthStep:false,
//        fifthStep:false,
//        maskStep:true
//      }
    }
  },
  components: {
    'v-header': header,
    'v-purchaserBanner': purchaserBanner,
    'v-dataCount': dataCount,
    'v-purchaserLogged': purchaserLogged,
    'v-notificationTop': notificationTop,
    'v-topBar': topBar,
    'v-publiceTit': publiceTit,
    'v-supplierEntryList': supplierEntryList,
    'v-collectingResources': collectingResources,
    'v-footer': footer,
    'v-backToTop': backToTop
  },
  computed: mapState([
    'KP',
    'leadSteps'
  ]),
  created () {
    if(this.getToken('isLogin') == 100){
      this.companyInfo = JSON.parse(this.getDAesString(this.getToken('companyInfo'),this.KP.key,this.KP.iv));
      this.userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
      this.companyId  = this.companyInfo.orgId;
      this.trueName  = this.companyInfo.trueName;
      this.userId  = this.companyInfo.userId;
      this.userTag = this.userInfo.userTag;

      let orgIdentity = this.companyInfo.orgIdentity;
      if(orgIdentity !=''){
        this.orgIdentitys = orgIdentity.split(",");
      }

      this.dialogVisible = true;
      if((/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent))) {
          this.visibleShow = false;
      }else {
        // 登录后协议弹框
        if (this.getToken('privacyPolicyFlag') == 1) {
            this.visibleShow = true;
        }
        // else {
        //   // 满意度调查
        //   this.surveyVisibleFn();
        // }
      }
    }
    this.$axios.post('/onelink.mdata.main.api/purchaserInfo/findPurchaserMainInfo', {
      columnType: 3,
      positionType: 2,
      receiveObjects: 1,
      currOrgIdentity:this.orgIdentitys,
      currPurchaserId: this.companyId ,
      currTrueName:this.trueName,
      currUid: this.userId,
      pageSize:8,
      pageNo:1,
      categoryId:1,
      userTag:this.userTag
    }).then((res) => {
      this.loading=false;
      this.data = res.data;
      this.ongoingRecruitProjectUrl = this.data.ongoingRecruitProjectUrl;
      this.viewExamineUrl = this.data.supplierInfo.viewExamineUrl;
      this.goEnterpriseResourceUrl = this.data.supplierInfo.goEnterpriseResourceUrl;
      this.coordinationSupplierUrl = this.data.coordinationSupplierUrl;
      this.recruitPurchaserUrl = this.data.recruitPurchaserUrl;
      this.recruitSupplierUrl = this.data.recruitSupplierUrl;
      this.mroShoppingMallUrl = this.data.mroShoppingMallUrl;
      this.ratationTime =  Number(this.data.ratationTime)*1000;
      this.navigationColumnInfos = this.data.navigationColumnInfos;
      this.noticeInfo = this.data.noticeDtos;
      this.companyConfigUrl = this.data.companyConfigUrl;
      this.footerColumnInfos = this.data.footerColumnInfos;
      this.hitSearchUrl = this.data.hitSearchUrl;
      this.yellowPageColumn = this.data.yellowPageColumn;
      this.productAndSolutionColumn = this.data.productAndSolutionColumn;
      this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      this.purchaserMenuList = this.data;
      this.bannerInfo = this.data.bannerPictureInfoDtos;
      this.paramInfo = this.data.paramInfoDto;
      this.webConfigInfo = this.data.webConfigInfoDto;
      this.warehousingUrl = this.data.supplierInfo.warehousingUrl;
      this.supplierEntryListMaterial = this.data.supplierInfo.supplierOptsExts;
      if(this.supplierEntryListMaterial == ""){
        this.supplierEntryListMaterial = [];
      }
      if(this.supplierEntryListMaterial.length >=0){
        this.supplierEntryListMaterial.forEach(element => {
          let reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
          if(reg.test(element.logoUrl)){
            element.logoUrl = encodeURI(element.logoUrl);
          }
        });
      }
      
      this.viewSupplierUrl = this.data.supplierInfo.viewSupplierUrl;
      if(this.supplierEntryListMaterial.length <= 0){
        this.noData = true;
      }
      // if(this.data.supplierInfo.supplierOptsExts){
      //   this.supplierLoad=false;
      // }
      this.hotList = this.data.supplierInfo.searchHotResponseExts;
      this.hitSerarchUrl = this.data.supplierInfo.hitSearchUrl;
      this.yellowPage = this.data.supplierInfo.supllierUrl;
      this.protocolInfo = this.data.protocolInfo;
      this.viewProtocolDetailUrl = this.data.protocolInfo.viewProtocolDetailUrl;
      this.viewMessageUrl = this.data.viewMessageUrl;
      this.supplierManagerUrl = this.data.supplierManagerUrl;
      this.coordinationManagerUrl = this.data.coordinationManagerUrl;
      this.coordinationSupplierAuthFlag = this.getToken('coordinationSupplierAuthFlag');
      this.coordinationSystemAuthFlag = this.getToken('coordinationSystemAuthFlag');
      this.supplierManagerAuthFlag = this.getToken('supplierManagerAuthFlag');
      this.supplierLoad=false;
    }).catch((err) => {
        console.log(err)
    })

  },
  mounted(){
    this.logOnAs();
    this.ulWidth();
    this.resizeUlWidth();
  },
  updated(){
    this.hasNotice();
  },
  watch:{
    leadSteps:{
      handler(val, oldVal){
        console.log("leadSteps.maskStep: "+val.maskStep, oldVal.maskStep);//但是这两个值打印出来却都是一样的
        // this.surveyVisibleFn();
        if(val.maskStep){
          $("html, body").animate({
            scrollTop: $(".purchaserLogged").offset().top-48 }, {duration: 500,easing: "swing"});
          return false;
        }
      },
      deep:true
    }
  },
  methods:{
    closeDialog() {
      this.dialogVisible = false;
      this.visibleShow = false;
    },
    ulWidth () {
      // 动态计算ul的宽度
      let scrollwrap = $('#supplierEntryTab')
      let lis = $('li', scrollwrap)
      let sum = 0
      // 遍历每一个li元素
      lis.each(function (index, el) {
        let _el = $(el)
        // width 宽度 代表的是内容的宽度 innerWidth 代表的是padding + width
        // outerWidth 代表的是border+padding+width
        sum += _el.width()
      })
      // 将累加的值直接复制给ul元素
      scrollwrap.width(sum + 7)
    },
    resizeUlWidth(){
      $(window).resize(() => {
        if($('.tabTitle').width() < 750){
        this.ulWidth();
      }else{
        $('#supplierEntryTab').width('auto')
      }
    })
    },
    jump(searchUrl,searchWord){
      window.location.href = searchUrl + searchWord;
    },
    jumpHome(searchUrl){
      this.searchWord = this.$refs.searchHit.value;
      window.location.href = searchUrl + this.searchWord;
    },
//    pc端more
    jumpPage(url){
      window.location.href = url;
    },
//    移动端more
    mobileBox(){
      this.$alert('<p>请在PC端查看</p>', '', {
        dangerouslyUseHTMLString: true,
        customClass:'mobileText',
        center: true
      });
    },
    selectCatagory(cataloryId){
      this.supplierLoad=true;
      this.$axios.post('/onelink.mdata.main.api/purchaserInfo/findSupplierInfo', {
        currOrgIdentity: [
          0
        ],
        currPurchaserId: 0,
        currTrueName: 0,
        currUid: 0,
        categoryId:cataloryId
      }).then((res) => {
        this.data = res.data;
        this.warehousingUrl = this.data.supplierInfo.warehousingUrl;
        if(cataloryId == 1){
          this.supplierEntryListMaterial = this.data.supplierInfo.supplierOptsExts;
          this.supplierEntryListMaterial.forEach(element => {
            let reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
            if(reg.test(element.logoUrl)){
              element.logoUrl = encodeURI(element.logoUrl);
            }
          });
          if(this.supplierEntryListMaterial.length>0){
            this.noData=false;
          }else{
            this.noData=true;
          }
          this.supplierLoad=false;
        }
        if(cataloryId == 2){
          this.supplierEntryListProject = this.data.supplierInfo.supplierOptsExts;
          this.supplierEntryListProject.forEach(element => {
            let reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
            if(reg.test(element.logoUrl)){
              element.logoUrl = encodeURI(element.logoUrl);
            }
        });
          if(this.supplierEntryListProject.length>0){
            this.noData=false;
          }else{
            this.noData=true;
          }
          this.supplierLoad=false
        }
        if(cataloryId == 3){
          this.supplierEntryListIndustry = this.data.supplierInfo.supplierOptsExts;
          this.supplierEntryListIndustry.forEach(element => {
            let reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
            if(reg.test(element.logoUrl)){
              element.logoUrl = encodeURI(element.logoUrl);
            }
        });
          if(this.supplierEntryListIndustry.length>0){
            this.noData=false;
          }else{
            this.noData=true;
          }
          this.supplierLoad=false
        }
        if(cataloryId == 4){
          this.supplierEntryListService = this.data.supplierInfo.supplierOptsExts;
          this.supplierEntryListService.forEach(element => {
            let reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
            if(reg.test(element.logoUrl)){
              element.logoUrl = encodeURI(element.logoUrl);
            }
        });
          if(this.supplierEntryListService.length>0){
            this.noData=false;
          }else{
            this.noData=true;
          }
          this.supplierLoad=false
        }
      }).catch((err) => {
          console.log(err)
      })

      // 埋点
      try {
        let tab_name;
        tab_name = cataloryId === 1 ? '物资类' : (cataloryId === 2 ? '工程类' : (cataloryId === 3 ? '工业类' : '服务类'))
        customTabClick({
          position: "采购商",
          tab_name: tab_name
        })
      } catch (e) {console.log(e)}
    },
    //    判断是否登录及登录身份 10供应商  20采购商
    logOnAs(){
      if(this.getToken('isLogin') == 100){
        let userTag = this.userInfo.userTag;
        if(userTag == '20' && this.leadSteps.maskStep){
          $("html, body").animate({
            scrollTop: $(".purchaserLogged").offset().top-48 }, {duration: 500,easing: "swing"});
          return false;
        }
      }
    },
    //      判断是否有公告通知
    hasNotice(){
//      console.log(Cookies.get('noticeLength'))
//      console.log(JSON.parse(this.getToken('noticeInfosExt')))
      if (this.getToken('isLogin') == 100) {
//        console.log(JSON.parse(this.getToken('noticeInfos')))
        if (JSON.parse(this.getToken('noticeInfos'))) {
          if (JSON.parse(this.getToken('noticeInfos')).length > 0) {
//            console.log('you');
            this.showNoticeInfo = true;
          } else {
            this.showNoticeInfo = false;
          }
        } else {
          this.showNoticeInfo = false;
        }
      } else {
        if (Cookies.get('noticeLength') != 0) {
          this.showNoticeInfo = true;
        } else {
          this.showNoticeInfo = false;
        }
      }
    }

//     //问卷调研是否显示
//     surveyVisibleFn(){
//       if(this.leadSteps.maskStep && (this.getToken('isOperateQuestionNaire') !== '' && this.getToken('isOperateQuestionNaire') == 0) && this.getToken('isLogin') == 100 && !(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent))){
//         this.surveyVisible=true;
//       }else{
//         this.surveyVisible=false;
//       }
//     },
// //    调研弹框事件
//     surveyFn(){
//       this.surveyDialogFn(false);
//     },
//     surveyDialogFn(val){
//       this.surveyVisible=false;
//       this.$axios.post('/onelink.mdata.main.api/web/operateQuestionNaire', {
//       }).then((res)=>{
//         if(res.data.code == 0){
//           if(val){
//             this.setToken('isOperateQuestionNaire',1);
//             window.location.href="https://www.lediaocha.com/pc/s/3q07dg5y";
//             // window.location.href="https://www.lediaocha.net/pc/s/23zpo8mn"
//           }else{
//             this.setToken('isOperateQuestionNaire',1);
//           }
//         }
//       })
//     },

  }
}
</script>

<style>
  #purchaser .custom-dialog .el-dialog {
    width: 480px;
    height: 338px;
  }

  #purchaser .custom-dialog .content {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    padding: 0 10px;
  }

  #purchaser .custom-dialog .content .left .p1 {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #303133;
    font-weight: 600;
  }
  #purchaser .custom-dialog .content .left .p2 {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #606266;
  }

  #purchaser .custom-dialog .content .right .qr {
    width: 120px;
    height: 120px;
    background: purple;
  }

  #purchaser .custom-dialog .content .right .qr-scan {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #A8ACB2;
    line-height: 12px;
    margin-top: 5px;
    text-align: center;
  }
  #purchaser .custom-dialog .footer {
    background: #fff;
    text-align: center;
    line-height: 32px;
  }

  #purchaser .custom-dialog .footer .know {
    width: 120px;
    height: 32px;
    background: #3F88E0;
    color: #fff;
    text-align: center;
    margin: 0 auto;
  }

  #purchaser .custom-dialog .footer .el-checkbox {
    margin-top: 15px;
  }

  #purchaser .custom-dialog .footer .el-checkbox__label {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #A8ACB2;
  }

  #purchaser .rule-dialog .el-dialog__footer {
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/pages/purchaser/index.vue